
import { useEffect, useMemo, useState } from 'react';
import { Button } from '@mui/material';
import toast from 'react-hot-toast';
import HttpClient from '../../../utils/HttpClient';

const ThirdForm = ({ onNext, onBack, formThreeData, setFormThreeData, location }) => {

    const [emailCheck, setEmailCheck] = useState(null)
    const [countries, setCountries] = useState([])
    // const [touchedFields, setTouchedFields] = useState({});
    const [CountryWiseState, setCountryState] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Process form data
        // const values = Object.values(formThreeData);
        // if (values.includes("")) {
        //     toast.error("Empty Field detected");
        //     return; // Stop further execution
        // }

        // Validation for telephone number
        const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        // const mobileRegex = /^\d{11}$/;
        // const telephoneRegex = /^\d{9}$/;

        // if (!telephoneRegex.test(formThreeData.telephoneNo)) {
        //     toast.error("Telephone number must be 9 digits and must not contain any special character and blank space");
        //     return;
        // }
        // else 
        if (parseInt(formThreeData.telephoneNo) < 0) {
            toast.error("Telephone number can not be  negative!");
            return;
        }
        // Validation for mobile number and WhatsApp number
        // else if (!mobileRegex.test(formThreeData.mobileNo)) {
        //     toast.error("Mobile number must be 11 digits and must not contain any special character and blank space");
        //     return;
        // }
        else if (parseInt(formThreeData.mobileNo) < 0) {
            toast.error("Mobile number  can not be  negative!");
            return;
        }
        // else if (!mobileRegex.test(formThreeData.whatsappNo)) {
        //     toast.error("WhatsApp number must be 11 digits and must not contain any special character and blank space");
        //     return;
        // }
        else if (parseInt(formThreeData.whatsappNo) < 0) {
            toast.error("WhatsApp number can not be  negative");
            return;
        }
        // Validation for email
        else if (!emailRegex.test(formThreeData.emailId)) {
            toast.error("Please enter a valid email");
            return;
        }
        else {
            const data = {
                "emailId": formThreeData?.emailId
            }

            if (location?.state) {
                onNext()
            } else {
                const res = await HttpClient.requestData("user-email-check", "POST", data)
                if (res && res?.status) {
                    setEmailCheck(res?.data?.status)
                    if (res?.data?.status === true) {
                        onNext()
                    }
                    else {
                        toast.error("email already exists")
                    }
                }
            }
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormThreeData(prev => ({ ...prev, [name]: value }));
    }

    const handleNumberChange = (e) => {
        const { name, value } = e.target
        // Ensure only positive numbers are entered
        // const newValue = Math.max(0, parseInt(value));
        setFormThreeData(prev => ({ ...prev, [name]: value }));
    }


    const Country = async () => {
        try {
            const res1 = await HttpClient.requestData("countries", "GET", {})
            if (res1 && res1?.status) {
                setCountries(res1?.data);
                // if (!location.state) {
                //     setFormThreeData({
                //         ...formThreeData,
                //         phone_code: res1.data[1].phone_code,
                //         whats_code: res1.data[1].phone_code,
                //     });
                // }
                if (!location?.state?.phone_code) {
                    setFormThreeData(prev => ({ ...prev, phone_code: res1.data[1].phone_code }));
                }
                if (!location?.state?.whats_code) {
                    setFormThreeData(prev => ({ ...prev, whats_code: res1.data[1].phone_code }));
                }
            }
        }
        catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    //state
    const getState = async () => {
        const res = await HttpClient.requestData(
            "countrywise-state/" + formThreeData.country,
            "GET",
            {}
        );

        if (res && res?.status) {
            setCountryState(res?.data?.[0]?.states);
        }
    };

    useEffect(() => {
        Country()
        if (location.state) {
            setFormThreeData({
                ...formThreeData,
                phone_code: location?.state?.phone_code || "+971",
                whats_code: location?.state?.whats_code || location?.state?.phone_code || "+971",
            });
        }
    }, [])

    useEffect(() => {
        getState();
    }, [formThreeData.country]);

    useEffect(() => {
        const countryName = countries.filter((item) => item?._id === formThreeData.country)
        setFormThreeData(prev => ({ ...prev, "countryName": countryName?.[0]?.name }));
    }, [formThreeData.country, countries]);

    const memoizedCountryTypes = useMemo(() => countries, [countries]);

    return (
        <form >
            <div className="row">
                <div className="col-md-12 mt-3 ">
                    <label >Telephone Number:<span className="text-danger">&nbsp;*</span></label>
                    <div style={{ display: "flex" }}>
                        <select
                            className="form-control col-2"
                            aria-label="Default select example"
                            name="phone_code"
                            value={formThreeData?.phone_code}
                            onChange={handleChange}
                        >
                            {countries.map((item, i) => (
                                <option key={i} value={item?.phone_code}>
                                    {item?.emoji} {item?.phone_code}
                                </option>
                            ))}
                        </select>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Telephone number"
                            name="telephoneNo"
                            maxLength={9}
                            value={formThreeData.telephoneNo}
                            onChange={handleNumberChange}
                        />
                    </div>
                </div>
                {/* Mobile */}
                <div className="col-md-12 mt-3 ">
                    <label >Mobile Number:<span className="text-danger">&nbsp;*</span></label>
                    <div style={{ display: "flex" }}>
                        <select
                            className="form-control col-2"
                            aria-label="Default select example"
                            name="phone_code"
                            value={formThreeData?.phone_code}
                            onChange={handleChange}
                        >
                            {countries.map((item, i) => (
                                <option key={i} value={item?.phone_code}>
                                    {item?.emoji} {item?.phone_code}
                                </option>
                            ))}
                        </select>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Mobile number"
                            name="mobileNo"
                            maxlength={11}
                            value={formThreeData?.mobileNo}
                            onChange={handleNumberChange}

                        />
                    </div>
                    {/* <input type="text" id="username" name="username" maxlength="10"></input> */}
                </div>
                {/* WhatsaApp */}
                <div className="col-md-12 mt-3 ">
                    <label >Whatsapp Number<span className="text-danger">&nbsp;*</span></label>
                    <div style={{ display: "flex" }}>
                        <select
                            className="form-control col-2"
                            aria-label="Default select example"
                            name="whats_code"
                            value={formThreeData?.whats_code}
                            onChange={handleChange}
                        >
                            {countries.map((item, i) => (
                                <option key={i} value={item?.phone_code}>
                                    {item?.emoji} {item?.phone_code}
                                </option>
                            ))}
                        </select>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Whatsapp number"
                            name="whatsappNo"
                            maxlength={11}
                            value={formThreeData.whatsappNo}
                            onChange={handleNumberChange}

                        />
                    </div>
                </div>
                {location?.state ? <div className="col-md-12 mt-3 ">
                    <label >Email ID<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Email ID"
                        name="emailId"
                        value={formThreeData.emailId}
                        onChange={handleChange}
                        readOnly

                    />
                </div> : <div className="col-md-12 mt-3 ">
                    <label >Email ID<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email ID"
                        name="emailId"
                        value={formThreeData.emailId}
                        onChange={handleChange}

                    />
                </div>}
                <div className="col-md-12 mt-3 ">
                    <label >Website Link<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Website Link"
                        name="websiteLink"
                        value={formThreeData.websiteLink}
                        onChange={handleChange}

                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Address<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Address"
                        name="address"
                        value={formThreeData.address}
                        onChange={handleChange}

                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Location<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Location"
                        name="location"
                        value={formThreeData.location}
                        onChange={handleChange}

                    />
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Country<span className="text-danger">&nbsp;*</span></label>
                    <select
                        className="form-control"
                        aria-label="Default select example"
                        name="country"
                        value={formThreeData.country}
                        onChange={handleChange}
                    >
                        <option value="" disabled>Select</option>
                        {memoizedCountryTypes.map((item, i) =>
                            <option key={i} value={item?._id}>{item?.name}</option>
                        )
                        }



                    </select>
                </div>
                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">State<span className="text-danger">&nbsp;*</span></label>
                    <select
                        className="form-control"
                        aria-label="Default select example"
                        name="emirate"
                        value={formThreeData.emirate}
                        onChange={handleChange}
                    >

                        <option value="" disabled>
                            Select State
                        </option>
                        {CountryWiseState?.map((item, i) => (
                            <option key={i} value={item?.name}>
                                {item?.name}
                            </option>
                        ))}


                    </select>
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Location Link<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Location Link"
                        name="locationLink"
                        value={formThreeData.locationLink}
                        onChange={handleChange}

                    />
                </div>

            </div>







            {/* Your form fields for the second step */}
            <Button onClick={onBack} variant="contained" className='mx-2 mt-2'>
                Back
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary" className='mx-2 mt-2'>
                Next
            </Button>
        </form>
    )
}

export default ThirdForm